import React from 'react'

import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'
import { useCurrentSurveyGroup } from '~/hooks/useCurrentSurveyGroup'
import { exists, type HeaderContentProps } from '~/utils'

import { type PathKey, useMatchedPathKey } from '../../routes/paths'

import { HeaderContentSurvey } from './components/HeaderContentSurvey'
import { HeaderContentSurveyGroup } from './components/HeaderContentSurveyGroup'
import styles from './HeaderContent.css'

export const nothingDisplayPathKeys: PathKey[] = [
  'strategyMemoArchiveList',
  'strategyMemoEdit',
  'strategyMemoList',
]

export const HeaderContent = (_props: HeaderContentProps) => {
  const matchedPathKey = useMatchedPathKey(nothingDisplayPathKeys)
  const currentSurveyGroup = useCurrentSurveyGroup()
  const currentSurvey = useCurrentSurvey()

  if (exists(matchedPathKey)) {
    return null
  }

  if (exists(currentSurveyGroup)) {
    return (
      <HeaderContentSurveyGroup
        className={styles.root}
        surveyGroupId={currentSurveyGroup.id}
      />
    )
  }

  if (currentSurvey.success) {
    return (
      <HeaderContentSurvey
        className={styles.root}
        surveyId={currentSurvey.value.id}
      />
    )
  }

  return null
}
